import * as React from "react"
import { changePassword } from "../auth/api"

const inputClass =
  "w-full border-2 border-slate-200 rounded-xl text-center p-2 mt-1 bg-white text-slate-800 placeholder:text-slate-400 focus:outline-none focus:border-cor-base transition-colors"

function Field({ label, children }) {
  return (
    <div>
      <label className="text-sm font-semibold text-slate-500 uppercase tracking-wide">
        {label}
      </label>
      {children}
    </div>
  )
}

export default function ChangePasswordModal({ onClose }) {
  const [form, setForm] = React.useState({
    senhaAtual: "",
    novaSenha: "",
    confirmarSenha: "",
  })
  const [error, setError] = React.useState("")
  const [loading, setLoading] = React.useState(false)
  const [success, setSuccess] = React.useState(false)

  function update(field, value) {
    setForm((prev) => ({ ...prev, [field]: value }))
  }

  // Fecha ao clicar fora
  function handleBackdropClick(e) {
    if (e.target === e.currentTarget) onClose()
  }

  // Fecha com Escape
  React.useEffect(() => {
    function onKey(e) { if (e.key === "Escape") onClose() }
    document.addEventListener("keydown", onKey)
    return () => document.removeEventListener("keydown", onKey)
  }, [onClose])

  async function handleSubmit(e) {
    e.preventDefault()
    setError("")
    setSuccess(false)

    if (form.novaSenha !== form.confirmarSenha) {
      setError("As senhas não coincidem.")
      return
    }
    if (form.novaSenha.length < 6) {
      setError("A nova senha deve ter pelo menos 6 caracteres.")
      return
    }

    try {
      setLoading(true)
      await changePassword({
        senhaAtual: form.senhaAtual,
        novaSenha: form.novaSenha,
      })
      setSuccess(true)
      setForm({ senhaAtual: "", novaSenha: "", confirmarSenha: "" })
      setTimeout(() => onClose(), 1400)
    } catch (err) {
      setError(err?.message || "Não foi possível alterar a senha.")
    } finally {
      setLoading(false)
    }
  }

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4"
      onClick={handleBackdropClick}
    >
      <div className="relative w-full max-w-sm bg-white rounded-2xl shadow-2xl">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 bg-cor-base rounded-t-2xl">
          <h2 className="text-xl font-oswald font-semibold text-white tracking-wide">
            Alterar senha
          </h2>
          <button
            onClick={onClose}
            className="text-white/70 hover:text-white text-2xl leading-none transition-colors"
            aria-label="Fechar"
            type="button"
          >
            ×
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="px-6 py-5 grid gap-4">
          <Field label="Senha atual">
            <input
              type="password"
              className={inputClass}
              value={form.senhaAtual}
              onChange={(e) => update("senhaAtual", e.target.value)}
              required
              autoComplete="current-password"
            />
          </Field>

          <Field label="Nova senha">
            <input
              type="password"
              className={inputClass}
              value={form.novaSenha}
              onChange={(e) => update("novaSenha", e.target.value)}
              required
              autoComplete="new-password"
            />
            <p className="text-xs text-slate-400 mt-1">Mínimo de 6 caracteres.</p>
          </Field>

          <Field label="Confirmar nova senha">
            <input
              type="password"
              className={inputClass}
              value={form.confirmarSenha}
              onChange={(e) => update("confirmarSenha", e.target.value)}
              required
              autoComplete="new-password"
            />
          </Field>

          {/* Feedback */}
          {error && (
            <p className="text-red-600 text-center text-sm font-semibold">
              {error}
            </p>
          )}
          {success && (
            <p className="text-green-600 text-center text-sm font-semibold">
              Senha alterada com sucesso!
            </p>
          )}

          {/* Actions */}
          <div className="flex gap-3 pt-1">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 py-2.5 rounded-xl border-2 border-slate-200 text-slate-600 font-semibold hover:bg-slate-50 transition-all"
            >
              Cancelar
            </button>
            <button
              type="submit"
              disabled={loading}
              className="flex-1 py-2.5 rounded-xl bg-cor-base text-white font-semibold hover:scale-[1.02] active:scale-[.97] transition-all disabled:opacity-60 disabled:cursor-not-allowed"
            >
              {loading ? "Alterando..." : "Alterar senha"}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}
